// The lecture screen of any Studio document (see output-panel.mjs): the content as learners
// see it in a lecture, drawn live, so it needs no server and is never out of date.
import { studioDocumentSubject } from './print-output.mjs';

export const lectureOutput = Object.freeze({
  id: 'lecture',
  path: 'lecture',
  noun: '강의 화면',
  live: true,
  intro: '학습자가 강의에서 보는 화면 그대로입니다. 쪽을 골라 가거나 스크롤해 이어 보고, 보이는 쪽을 바로 고칠 수 있습니다.',
  subjectOf: studioDocumentSubject,
  // Things the Studio does with it; the panel shows an action only when the Studio gives its hook.
  actions: Object.freeze([
    Object.freeze({ id: 'course', label: '강좌에 올리기', hook: 'openCourse' }),
    Object.freeze({ id: 'reading', label: '전체 화면으로 보기', hook: 'openReading' }),
  ]),
});
